// extracted by mini-css-extract-plugin
export default {"wrap":"LoadingSpinner_wrap__5o1fM","message":"LoadingSpinner_message__garYX"};